<template>
    <div class="page-tab-container">
        <div class="page-tab">
            <div class="page-tab-title">
                Skills
            </div>
            <div class="page-tab-options row">
                <TagsInput v-model="search_query" @input="seachMetricsBySkills" :canAutoComplete="true"
                    :useSuggestionsOnly="true" @autoCompleteCallback="searchExistingSkills" inputWidth="150px"
                    :icon="require('@/assets/icons/search.svg')" />
                <div class="h-spacer"></div>
                <widgetDropdown v-model="showDepartmentDropdown" :right="true" :hover="false" :interactive="true">
                    <button class="btn-dropdown">
                        <span>Schools:{{ selectedDepartment ? selectedDepartment : 'All' }}</span>
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                    </button>
                    <div slot="dropdown" class="dropdown-widget right">
                        <a class="dropdown-item" href="#" v-for="(item, index) in departments" :key="index"
                            @click="onSelectDepartment(item)">
                            {{ item.name }}</a>
                    </div>
                </widgetDropdown>
                <div class="h-spacer" v-if="filterForm.selectedDepartment"></div>
                <widgetDropdown v-if="filterForm.selectedDepartment" v-model="showTeamDropdown" :right="true"
                    :hover="false" :interactive="true">
                    <button class="btn-dropdown">
                        <span>Classes:{{ selectedTeam ? selectedTeam : 'All' }}</span>
                        <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                    </button>
                    <div slot="dropdown" class="dropdown-widget right">
                        <a class="dropdown-item" href="#" v-for="(item, index) in teams" :key="index"
                            @click="onSelectTeam(item)">
                            {{ item.name }}</a>
                    </div>
                </widgetDropdown>
                <div class="h-spacer"></div>
                <widgetButton :loading="false" @click="ViewConsultant()" class="btn-secondary">
                    View matching students
                </widgetButton>
            </div>
        </div>

        <div v-if="matrix_maching" class="search-matching-widget">
            <div class="search-matching-count">
                Total matching students <b>{{ matrix_maching.matching }}</b>
            </div>
            <div class="search-matching-progress">
                <div class="matching-progress-top-labels">
                    <span class="label-left">{{ parseFloat(matrix_maching.matching_percentage) }}%</span>
                    <span class="label-right">{{ parseFloat(matrix_maching.others_percentage) }}%</span>
                </div>
                <div class="matching-progress-wrapper">
                    <div class="matching-progress-bar"
                        :style="{ width: `${parseFloat(matrix_maching.matching_percentage)}%` }"></div>
                </div>
                <div class="matching-progress-bottom-labels">
                    <span class="label-left">Matching students</span>
                    <span class="label-right">Others</span>
                </div>
            </div>
        </div>
        <div v-if="matrix_maching" class="search-matching-title">
            Other skills from these students
        </div>

        <div v-if="!loadingMetrics && isSkillsAvailable" class="page-body">
            <div class="row">
                <div class="skills-chart-widget">
                    <apexchart ref="toolsChart" type="donut" width="100%" height="100%" :options="tools.chartOptions"
                        :series="tools.series">
                    </apexchart>
                </div>
                <div class="h-spacer">
                </div>
                <div class="skills-chart-widget">
                    <apexchart ref="domainsChart" type="donut" width="100%" height="100%"
                        :options="domains.chartOptions" :series="domains.series">
                    </apexchart>
                </div>
            </div>
            <div class="row">
                <div class="skills-chart-widget">
                    <apexchart ref="competencesChart" type="donut" width="100%" height="100%"
                        :options="competences.chartOptions" :series="competences.series">
                    </apexchart>
                </div>
                <div class="h-spacer">
                </div>
                <div class="skills-chart-widget">
                    <apexchart ref="rolesChart" type="donut" width="100%" height="100%" :options="roles.chartOptions"
                        :series="roles.series">
                    </apexchart>
                </div>
            </div>
        </div>
        <!-- Loading preview -->
        <div class="page-body loading-widget" v-if="loadingMetrics">
            <loading :height="40" :width="40" :active="true" color="#1ba5a4" background-color="#fff"
                :is-full-page="false" />
        </div>

        <div v-if="!loadingMetrics && !isSkillsAvailable" class="page-body">
            <widgetNotFoundWidget title="Result not Found" content="No result found for your search">
                <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
            </widgetNotFoundWidget>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";

export default {
    components: {

    },
    props: {
        form: {
            type: Object,
            default: null
        },
    },
    data: () => {
        let vm = this;
        return {
            showTeamDropdown: false,
            selectedTeam: null,
            search_query: {
                added: [],
                removed: [],
            },
            teams: [
                {
                    name: "All",
                    value: null,
                }
            ],
            // Department Dropdown
            showDepartmentDropdown: false,
            selectedDepartment: null,
            departments: [
                {
                    name: "All",
                    value: null,
                }
            ],
            // Department
            filterForm: {
                skills: [],
                selectedDepartment: null,
                selectedTeam: null,
            },
            tools: {
                series: [],
                // Add labels to the chart
                chartOptions: {
                    labels: [],
                    colors: [],
                    chart: {
                        type: 'donut',
                        events: {
                            dataPointSelection: function (event, chartContext, config) {
                                const obj = {
                                    name: chartContext.opts.labels[config.dataPointIndex],
                                    value: 'tool'
                                }
                                window.updateFilterSkillTags(obj);
                            }

                        }
                    },
                    legend: {
                        show: true,
                        showForSingleSeries: false,
                        showForNullSeries: true,
                        showForZeroSeries: true,
                        position: 'left',
                        horizontalAlign: 'left',
                        fontFamily: 'Nunito',
                        fontWeight: 400,
                        offsetX: 0,
                        offsetY: 0,
                        itemMargin: {
                            horizontal: 5,
                            vertical: 10
                        },
                        formatter: function (seriesName, opts) {
                            return seriesName.length > 35 ? seriesName.substring(0, 35) + '...' : seriesName;
                        }
                    },
                    plotOptions: {
                        pie: {
                            expandOnClick: true,
                            offsetX: 0,
                            donut: {
                                size: '50%',
                                labels: {
                                    show: true,
                                    name: {
                                        show: true,
                                        fontSize: '25px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 8
                                    },
                                    value: {
                                        show: true,
                                        fontSize: '16px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 16,
                                        formatter: function (val) {
                                            return val + "%"
                                        }
                                    },
                                    total: {
                                        show: true,
                                        label: 'Tools',
                                        color: '#000',
                                        formatter: function (w) {
                                            return ""
                                        }
                                    }
                                }
                            }
                        }
                    },
                },
            },
            domains: {
                series: [],
                // Add labels to the chart
                chartOptions: {
                    labels: [],
                    colors: [],
                    chart: {
                        type: 'donut',
                        events: {
                            dataPointSelection: function (event, chartContext, config) {
                                const obj = {
                                    name: chartContext.opts.labels[config.dataPointIndex],
                                    value: 'domain'
                                }
                                window.updateFilterSkillTags(obj);
                            }

                        }
                    },
                    legend: {
                        show: true,
                        showForSingleSeries: false,
                        showForNullSeries: true,
                        showForZeroSeries: true,
                        position: 'left',
                        horizontalAlign: 'left',
                        fontFamily: 'Nunito',
                        fontWeight: 400,
                        offsetX: 0,
                        offsetY: 0,
                        itemMargin: {
                            horizontal: 5,
                            vertical: 10
                        },
                        formatter: function (seriesName, opts) {
                            return seriesName.length > 35 ? seriesName.substring(0, 35) + '...' : seriesName;
                        }

                    },
                    plotOptions: {
                        pie: {
                            expandOnClick: true,
                            offsetX: 0,
                            donut: {
                                size: '50%',
                                labels: {
                                    show: true,
                                    name: {
                                        show: true,
                                        fontSize: '25px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 8
                                    },
                                    value: {
                                        show: true,
                                        fontSize: '16px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 16,
                                        formatter: function (val) {
                                            return val + "%"
                                        }
                                    },
                                    total: {
                                        show: true,
                                        label: 'Domains',
                                        color: '#000',
                                        formatter: function (w) {
                                            return ""
                                        }
                                    }
                                }
                            }
                        }
                    },
                },
            },
            competences: {
                series: [],
                // Add labels to the chart
                chartOptions: {
                    labels: [],
                    colors: [],
                    chart: {
                        type: 'donut',
                        events: {
                            dataPointSelection: function (event, chartContext, config) {
                                const obj = {
                                    name: chartContext.opts.labels[config.dataPointIndex],
                                    value: 'competence'
                                }
                                window.updateFilterSkillTags(obj);
                            }

                        }
                    },
                    legend: {
                        show: true,
                        showForSingleSeries: false,
                        showForNullSeries: true,
                        showForZeroSeries: true,
                        position: 'left',
                        horizontalAlign: 'left',
                        fontFamily: 'Nunito',
                        fontWeight: 400,
                        offsetX: 0,
                        offsetY: 0,
                        itemMargin: {
                            horizontal: 5,
                            vertical: 10
                        },
                        formatter: function (seriesName, opts) {
                            return seriesName.length > 35 ? seriesName.substring(0, 35) + '...' : seriesName;
                        }

                    },
                    plotOptions: {
                        pie: {
                            expandOnClick: true,
                            offsetX: 0,
                            donut: {
                                size: '50%',
                                labels: {
                                    show: true,
                                    name: {
                                        show: true,
                                        fontSize: '25px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 8
                                    },
                                    value: {
                                        show: true,
                                        fontSize: '16px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 16,
                                        formatter: function (val) {
                                            return val + "%"
                                        }
                                    },
                                    total: {
                                        show: true,
                                        label: 'Competences',
                                        color: '#000',
                                        formatter: function (w) {
                                            return ""
                                        }
                                    }
                                }
                            }
                        }
                    },
                },
            },
            roles: {
                series: [],
                // Add labels to the chart
                chartOptions: {
                    labels: [],
                    colors: [],
                    chart: {
                        type: 'donut',
                        events: {
                            dataPointSelection: function (event, chartContext, config) {
                                const obj = {
                                    name: chartContext.opts.labels[config.dataPointIndex],
                                    value: 'role'
                                }
                                window.updateFilterSkillTags(obj);
                            }

                        }
                    },
                    legend: {
                        show: true,
                        showForSingleSeries: false,
                        showForNullSeries: true,
                        showForZeroSeries: true,
                        position: 'left',
                        horizontalAlign: 'left',
                        fontFamily: 'Nunito',
                        fontWeight: 400,
                        offsetX: 0,
                        offsetY: 0,
                        itemMargin: {
                            horizontal: 5,
                            vertical: 10
                        },
                        formatter: function (seriesName, opts) {
                            return seriesName.length > 35 ? seriesName.substring(0, 35) + '...' : seriesName;
                        }
                    },
                    plotOptions: {
                        pie: {
                            expandOnClick: true,
                            offsetX: 0,
                            donut: {
                                size: '50%',
                                labels: {
                                    show: true,
                                    name: {
                                        show: true,
                                        fontSize: '25px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 8
                                    },
                                    value: {
                                        show: true,
                                        fontSize: '16px',
                                        fontFamily: 'Nunito',
                                        color: undefined,
                                        offsetY: 16,
                                        formatter: function (val) {
                                            return val + "%"
                                        }
                                    },
                                    total: {
                                        show: true,
                                        label: 'Roles',
                                        color: '#000',
                                        formatter: function (w) {
                                            return ""
                                        }
                                    }
                                }
                            }
                        }
                    },
                },
            },
            loadingMetrics: false,
            matrix_maching: null,
        }
    },
    mounted() {
        let vm = this;
        window.updateFilterSkillTags = (obj) => {
            let vm = this;
            vm.search_query.added.push(obj);
            vm.seachMetricsBySkills(vm.search_query);
        };
        vm.getAllDepartment();
        vm.getMatrixData();
    },
    computed: {
        isSkillsAvailable: function () {
            let vm = this;
            return vm.tools.series.length > 0 || vm.domains.series.length > 0 || vm.competences.series.length > 0 || vm.roles.series.length > 0;
        },
    },
    watch: {

    },
    methods: {
        seachMetricsBySkills(val) {
            let vm = this;
            vm.filterForm.skills = {
                tool: [],
                domain: [],
                competence: [],
                role: []
            }
            if (val.added.length > 0) {
                val.added.filter(item => item.value != null).forEach(item => {
                    vm.filterForm.skills[item.value].push(item.name);
                });
            } else {
                vm.filterForm.skills = [];
            }
            vm.getMatrixData();
        },
        searchExistingSkills(query, callback) {
            let vm = this;
            vm.$store
                .dispatch("MATRIX_SEARCH_SKILLS", {
                    query: query
                })
                .then((responce) => {
                    let data = responce.data.map(item => {
                        return {
                            name: item.name,
                            value: item.item,
                        }
                    });
                    callback(data);
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        ViewConsultant() {
            let vm = this;
            vm.$emit('ViewConsultantsProfiles', vm.filterForm)
        },
        getMatrixMatchingDetails() {
            let vm = this;
            vm.$store
                .dispatch("GET_ALL_MATRIX_MATCHING_DATA", vm.filterForm)
                .then((responce) => {
                    vm.matrix_maching = responce.data;
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        getMatrixData() {
            let vm = this;
            vm.getMatrixMatchingDetails();
            vm.loadingMetrics = true;
            vm.$store
                .dispatch("GET_ALL_MATRIX_DATA", vm.filterForm)
                .then((responce) => {
                    vm.processToolsData(responce);
                    vm.processDomainsData(responce);
                    vm.processCompetencesData(responce);
                    vm.processRolesData(responce);
                    vm.loadingMetrics = false;

                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        processToolsData(responce) {
            let vm = this;
            let labels = responce.data.tools.labels.map(item => {
                return item;
            });
            let series = responce.data.tools.series.map(item => {
                return parseInt(item);
            });
            let colorsToPick = ['#FEBD38', '#0884AF', '#FE464B', '#FF5CBE', '#15ADAC'];
            let colors = responce.data.tools.labels.map((item, index) => {
                if (colorsToPick[index % colorsToPick.length]) {
                    return colorsToPick[index % colorsToPick.length];
                } else {
                    return '#FEBD38';
                }
            });


            vm.tools.series = series;
            vm.tools.chartOptions.labels = labels;
            vm.tools.chartOptions.colors = colors;

        },
        processDomainsData(responce) {
            let vm = this;
            let labels = responce.data.domains.labels.map(item => {
                return item;
            });
            let series = responce.data.domains.series.map(item => {
                return parseInt(item);
            });
            let colorsToPick = ['#FEBD38', '#0884AF', '#FE464B', '#FF5CBE', '#15ADAC'];
            let colors = responce.data.tools.labels.map((item, index) => {
                if (colorsToPick[index % colorsToPick.length]) {
                    return colorsToPick[index % colorsToPick.length];
                } else {
                    return '#FEBD38';
                }
            });
            vm.domains.series = series;
            vm.domains.chartOptions.labels = labels;
            vm.domains.chartOptions.colors = colors;

        },
        processCompetencesData(responce) {
            let vm = this;
            let labels = responce.data.competences.labels.map(item => {
                return item;
            });
            let series = responce.data.competences.series.map(item => {
                return parseInt(item);
            });
            let colorsToPick = ['#FEBD38', '#0884AF', '#FE464B', '#FF5CBE', '#15ADAC'];
            let colors = responce.data.tools.labels.map((item, index) => {
                if (colorsToPick[index % colorsToPick.length]) {
                    return colorsToPick[index % colorsToPick.length];
                } else {
                    return '#FEBD38';
                }
            });
            vm.competences.series = series;
            vm.competences.chartOptions.labels = labels;
            vm.competences.chartOptions.colors = colors;


        },
        processRolesData(responce) {
            let vm = this;
            let labels = responce.data.roles.labels.map(item => {
                return item;
            });
            let series = responce.data.roles.series.map(item => {
                return parseInt(item);
            });
            let colorsToPick = ['#FEBD38', '#0884AF', '#FE464B', '#FF5CBE', '#15ADAC'];
            let colors = responce.data.tools.labels.map((item, index) => {
                if (colorsToPick[index % colorsToPick.length]) {
                    return colorsToPick[index % colorsToPick.length];
                } else {
                    return '#FEBD38';
                }
            });
            vm.roles.series = series;
            vm.roles.chartOptions.labels = labels;
            vm.roles.chartOptions.colors = colors;

        },
        getAllDepartment() {
            let vm = this;
            vm.$store
                .dispatch("GET_ALL_DEPARTMENT")
                .then((responce) => {
                    let initialData = [{
                        name: "All",
                        value: null,
                    }];
                    responce.data.map(item => {
                        return {
                            name: item.name,
                            value: item.id,
                        }
                    }).forEach(item => {
                        initialData.push(item);
                    });
                    vm.departments = initialData;
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        getDepartmentTeams() {
            let vm = this;
            vm.$store
                .dispatch("GET_ALL_DEPARTMENT_TEAMS", {
                    departmentId: vm.filterForm.selectedDepartment
                })
                .then((responce) => {
                    let initialData = [{
                        name: "All",
                        value: null,
                    }];
                    responce.data.map(item => {
                        return {
                            name: item.name,
                            value: item.id,
                        }
                    }).forEach(item => {
                        initialData.push(item);
                    });
                    vm.teams = initialData;
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        onSelectDepartment(item) {
            let vm = this;
            vm.filterForm.selectedDepartment = item.value;
            vm.selectedDepartment = item.name;
            vm.showDepartmentDropdown = false;
            vm.getDepartmentTeams();
            vm.getMatrixData();
        },
        onSelectTeam(item) {
            let vm = this;
            vm.filterForm.selectedTeam = item.value;
            vm.selectedTeam = item.name;
            vm.showTeamDropdown = false;
            vm.getMatrixData();
        }
    },

};
</script>

<style lang="scss" scoped>
.page-tab-container {
    height: calc(100% - 38px);
    display: flex;
    flex-direction: column;

    .page-tab {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        background: #fff;
        margin-bottom: 5px;
        border-radius: 5px;
        padding: 0px 20px;

        .page-tab-title {
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #0A88AD;
        }


        .page-tab-options {
            .btn-dropdown {
                background: #F7F7F7;
                border-radius: 5px;
                height: 30px;
                padding: 0px 10px;
            }
        }
    }

    .search-matching-widget {
        background: #fff;
        border-radius: 5px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 15px;

        .search-matching-count {
            font-size: 15px;
        }

        .search-matching-progress {
            .matching-progress-top-labels {
                display: flex;
                justify-content: space-between;
                width: 100%;
            }

            .matching-progress-wrapper {
                width: 280px;
                height: 10px;
                background: #1890BD;
                display: flex;
                align-items: center;
                overflow: hidden;
                border-radius: 3px;

                .matching-progress-bar {
                    background: #FFC236;
                    width: 80%;
                    height: 100%;
                }
            }

            .matching-progress-bottom-labels {
                display: flex;
                justify-content: space-between;
                width: 100%;
            }
        }
    }

    .search-matching-title {
        height: 35px;
        display: flex;
        align-items: center;
        padding: 0px 15px;
        font-size: 15px;
    }

    .page-body {
        height: calc(100% - 60px);
        padding-bottom: 60px;
        position: relative;
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .skills-chart-widget {
            height: 320px;
            width: 50%;
            padding: 25px;
            background: #fff;
            border-radius: 5px;
            align-self: flex-start;
            margin-bottom: 10px;
        }

    }
}
</style>